export default __webpack_public_path__ + "static/media/ellipse2.249856ca.png";